import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import classNames from 'classnames';
import { SubTableHeading } from '../../../common/SubTable/SubTableHeading';
import SubTable from '../../../common/SubTable/SubTable';
import { CaptionCell } from '../common/CaptionCell';
import { sumNumbersNullish } from '../../../utils/number';
import s from '../ParentalAssistanceGuidelinesOrganizational/ParentalAssistanceGuidelinesOrganizationalPage.module.scss';

export const ResultSection = ({ data }) => {
  return (
    <SubTable cols={3}>
      <SubTableHeading cols={3}>III. Результаты оказания услуг</SubTableHeading>
      <TableRow>
        <CaptionCell className={s.questionCell}>Показатель</CaptionCell>
        <CaptionCell className={s.valueCell}>2019 год</CaptionCell>
        <CaptionCell className={s.valueCell}>
          2020 год (на 01.11.2020 г.)
        </CaptionCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={s.questionCell}>
          1. Количество оказанных услуг всего (единиц)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_lended_f2f_services_2019 +
              data.amount_of_lended_remote_services_2019 +
              data.amount_of_lended_field_services_2019 +
              data.amount_of_lended_another_format_services_2019
          ) || 0}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_lended_f2f_services_2020 +
              data.amount_of_lended_remote_services_2020 +
              data.amount_of_lended_field_services_2020 +
              data.amount_of_lended_another_format_services_2020
          ) || 0}
        </CaptionCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в формате очных консультаций
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_f2f_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_f2f_services_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в формате дистанционных консультаций
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_remote_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_remote_services_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в формате выездных консультаций
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_field_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_field_services_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в ином формате (если предусмотрено)
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_another_format_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_another_format_services_2020}
        </TableCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={s.questionCell}>
          2. Количество оказанных услуг всего (единиц)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_lended_free_services_2019 +
              data.amount_of_lended_paid_services_2019
          ) || 0}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_lended_free_services_2020 +
              data.amount_of_lended_paid_services_2020
          ) || 0}
        </CaptionCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе без взимания платы
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_free_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_free_services_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе на платной основе
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_paid_services_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_lended_paid_services_2020}
        </TableCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={s.questionCell}>
          3. Количество получателей услуги, всего (человек)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_onetime_service_recipients_2019 +
              data.amount_of_multipletimes_service_recipients_2019
          ) || 0}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_onetime_service_recipients_2020 +
              data.amount_of_multipletimes_service_recipients_2020
          ) || 0}
        </CaptionCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе обратившихся единовременно
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_onetime_service_recipients_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_onetime_service_recipients_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе обратившихся более одного раза
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_multipletimes_service_recipients_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_multipletimes_service_recipients_2020}
        </TableCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={s.questionCell}>
          4. Количество специалистов, оказывающих услуги, всего (человек)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_specialists_in_state_2019 +
              data.amount_of_contract_specialists_2019
          ) || 0}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {sumNumbersNullish(
            data.amount_of_specialists_in_state_2020 +
              data.amount_of_contract_specialists_2020
          ) || 0}
        </CaptionCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе состоящих в штате организации
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_specialists_in_state_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_specialists_in_state_2020}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - в том числе привлеченных по договору{' '}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_contract_specialists_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.amount_of_contract_specialists_2020}
        </TableCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={classNames(s.questionCell, s.title)}>
          5. Количество специалистов, оказывающих услуги, прошедших обучение по
          дополнительной профессиональной программе для специалистов, всего
          (человек)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {data.amount_of_prepared_specialists_2019}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {data.amount_of_prepared_specialists_2020}
        </CaptionCell>
      </TableRow>

      <TableRow>
        <CaptionCell className={s.questionCell}>
          6. Количество отказов в предоставлении услуги, всего (ед.)
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {data.amount_of_service_rejections_2019}
        </CaptionCell>
        <CaptionCell className={s.valueCell}>
          {data.amount_of_service_rejections_2020}
        </CaptionCell>
      </TableRow>
      <TableRow>
        <TableCell className={s.questionCell}>
          - перечислите основные причины отказов в предоставлении услуги без
          взимания платы.
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.service_rejections_description_2019}
        </TableCell>
        <TableCell className={s.valueCell}>
          {data.service_rejections_description_2020}
        </TableCell>
      </TableRow>
    </SubTable>
  );
};
